
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.393 0L5.908 5.32a4.161 4.161 0 00-1.775-.389C1.852 4.931 0 6.739 0 8.966 0 11.192 1.852 13 4.133 13c2.28 0 4.132-1.808 4.132-4.034 0-.12 0-.225-.015-.344l1.01-.702-.382-.673.765-.523-.153-.896.612-.449 1.224.523.46-.373-.153-.972.612-.448.612.3.383-.225-.077-.673.46-.373.918.448.459-.299-.306-2.54-6.888 4.856L7.5 5.08 14.464.15 13.393 0zm-9.26 5.529c1.944 0 3.52 1.539 3.52 3.437 0 1.897-1.576 3.436-3.52 3.436S.613 10.863.613 8.966c0-1.898 1.576-3.437 3.52-3.437zm-.077.448C2.326 5.977.918 7.352.918 9.04c0 1.689 1.409 3.063 3.138 3.063 1.73 0 3.138-1.374 3.138-3.063 0-1.688-1.408-3.063-3.138-3.063zm-.842 2.39c.674 0 1.225.539 1.225 1.196 0 .658-.551 1.196-1.225 1.196-.673 0-1.224-.538-1.224-1.196 0-.657.55-1.195 1.224-1.195z","fill":"currentColor"}})])
          )
        }
      }
    